import apiClient from "api-client";

import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useGetItineraryBookletsDocumentTest = getWrappedUseQuery(
  KEYS.GET_ITINERARY_BOOKLETS_DOCUMENT_TEST,
  apiClient.itineraryBookletsDocumentTest.get,
);
